<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>经历</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="queryParams.code" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.person_rid">
                <vDropdown
                    model_key="person_rid"
                    model_name="请选择人员"
                    :model_value_default="queryParams['person_rid']"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="person_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.classification">
                <vDropdown
                    model_key="classification"
                    model_name="请选择类别"
                    select_value="value"
                    request_uri="dropdownExperienceClassification"
                    :model_value_default="queryParams['classification']"
                    @onDropChange="onDropChange"
                    ref="classification_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.type">
                <vDropdown
                    model_key="type"
                    model_name="请选择类型"
                    select_value="value"
                    request_uri="dropdownExperienceType"
                    :model_value_default="queryParams['type']"
                    @onDropChange="onDropChange"
                    ref="type_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.educational">
                <vDropdown
                    model_key="educational"
                    model_name="请选择学历"
                    select_value="value"
                    request_uri="dropdownEducational"
                    :model_value_default="queryParams['educational']"
                    @onDropChange="onDropChange"
                    ref="educational_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.entity">
                <el-input v-model="queryParams.entity" placeholder="请输入单位" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.date">
                <el-date-picker
                    v-model="queryParams['date']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="person_experience" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="person_experience"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['code', 'person'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'personExperienceComponent',
    data() {
        return {
            draggable: {
                data_name: 'person_experience'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                this.queryParams.row = 10;
                this.queryParams.person_rid = this.postList.params.person_rid;

                if (this.postList.params.order_by) {
                    this.queryParams.order_by = this.postList.params.order_by;
                }

                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['code']) && row.rid) {
                this.$router.push({
                    path: '/personExperienceDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'person' && row.person_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.person_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                order_by: {},
                code: '',
                person_rid: '',
                classification: '',
                type: '',
                educational: '',
                entity: '',
                date: ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('person_experience_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('person_experience_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('person_experience', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).person_experience;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'personExperienceLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            if (this.$refs.person_rid_ref) {
                this.$refs.person_rid_ref.reset();
            }
            this.initQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.person_rid = this.postList.params.person_rid;
            }

            this.getList();
        },
        //新增
        insert() {
            this.$router.push({
                path: 'personExperienceEdit',
                query: {
                    type: 'insert',
                    person_rid: (this.postList.params && this.postList.params.person_rid) || ''
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'personExperienceEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'personExperienceEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'personExperienceDelete', row.name);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>